import Vue from 'vue'
import VueI18n from 'vue-i18n';

// VueアプリケーションでVueI18nプラグインを使う宣言
Vue.use(VueI18n);

// メッセージ定義ファイルの読み込み
import messages from './messages';

// デフォルト言語の設定s
export const DEFAULT_LANG = 'ja';

// 言語切替用の定義
export const enableLanguages = Object.keys(messages);
export const langCodes = {
  ja: '日本語',
  en: 'English',
};

// VueI18nインスタンスの生成（言語とメッセージオブジェクトを渡す）
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages,
});

export default i18n;
